import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import NewArrivals from "./NewArrivals";

export default function NewArrivalsSwiper() {
  const [newArrivals, setNewArrivals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  // Fetch new arrivals from the API
  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/new-arrival`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setNewArrivals(data.new_arrivals);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching new arrivals:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNewArrivals();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]"></div>
      </div>
    );
  }

  // UPDATED: Combined Error and Empty state to show a friendly message
  if (error || !newArrivals.length) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-gray-50/50 rounded-lg border border-[#D4AF37]/10">
        <div className="text-center">
            <p className="text-gray-400 text-lg font-medium tracking-wide" style={{ fontFamily: "Montserrat, serif" }}>
                No new arrivals available at the moment.
            </p>
            <p className="text-gray-300 text-sm mt-2">Check back soon for our latest collections!</p>
        </div>
      </div>
    );
  }

  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={20}
      slidesPerView={1}
      autoplay={{ delay: 3000 }}
      breakpoints={{
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="py-4"
    >
      {newArrivals.map((product, index) => (
        <SwiperSlide key={index}>
          <NewArrivals product={product} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}